/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const updateCalculatedInterestData = (data) => ({
  type: actionTypes.SET_CALCULATED_INTEREST_DATA,
  payload: data,
});
export const selectedInterestDetails = (data) => ({
  type: actionTypes.SELECTED_INTEREST_DETAILS,
  payload: data,
});

export const calculatedInterestPayload = (data) => ({
  type: actionTypes.CALCUALTED_DETAILS_PAYLOAD,
  payload: data,
});
export const setDrugInterestResposne = (data) => ({
  type: actionTypes.RESPONSE_GET_DRUG_INTEREST,
  payload: data,
});
export const calculateUserInputs = (data) => ({
  type: actionTypes.CALULATED_USER_INPUTS,
  payload: data,
});

export const fetchSearchScreenReduxData = (data) => ({
  type: actionTypes.GET_SEARCH_SCREEN_DATA,
  payload: data,
});
export const setSelectedRebateProgram = (val) => {
  return {
    type: actionTypes.SELECTED_REBATE_PROGRAM,
    selectedRebateProgram: val,
  };
};
export const setSelManIdAction = (val) => {
  return {
    type: actionTypes.SELECTED_MFG,
    selectedGrid: val,
  };
};
export const clearReduxCalculatedInterest = () => (dispatch) => {
  dispatch(setSelManIdAction([]));
  localStorage.setItem('selectedMfgIds', JSON.stringify([]));
  dispatch(setSelectedRebateProgram([]));
  dispatch(fetchSearchScreenReduxData([]));
};


